// Chutzpah motion (the hero star, vowel marks and the stamp landing). Every effect is an enhancement: the hidden start
// states hang off <html class="ch-motion">, which only this theme's inline head script adds, so without scripts
// everything simply shows in place. Dawn handles the rest (sticky header, reveal on scroll, cart).
(() => {
  const watch = (els, opts, onEnter) => {
    if (!('IntersectionObserver' in window)) return els.forEach((el) => onEnter(el));
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) if (e.isIntersecting) { onEnter(e.target); io.unobserve(e.target); }
    }, opts);
    els.forEach((el) => io.observe(el));
  };

  // Hero star: once it has landed, hover elbows it harder and a click replays the slap
  const initStar = (star) => {
    if (star.dataset.ready) return;
    star.dataset.ready = '1';
    star.addEventListener('animationend', (e) => { if (e.target.classList?.contains('cream')) star.classList.add('settled'); });
    star.addEventListener('click', () => {
      star.classList.remove('settled');
      star.classList.add('replay');
      star.getBoundingClientRect(); // restart the keyframes
      star.classList.remove('replay');
    });
  };

  const init = (root = document) => {
    root.querySelectorAll('.ch-star').forEach(initStar);
    // Vowel marks and the stamp land once they are properly in view
    watch([...root.querySelectorAll('[data-land]:not(.landed)')], { threshold: 0.6 }, (el) => el.classList.add('landed'));
  };

  init();
  // Theme editor: sections re-render in place
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
